/* eslint-disable react/prop-types */
import React from 'react';
import { batch, useDispatch } from 'react-redux';
import {
  decreaseCartQuantity,
  deleteCartItem,
  increaseCartQuantity
} from '../../../../redux/CartItem/actionCreators';
import {
  decreaseProductQuantity,
  increaseProductQuantity,
  resetProductQuantity
} from '../../../../redux/ProductItem/actioCreators';

function CartItem({ cartItem }) {
  // Destructuring cart item data from cart object
  const {
    productId,
    productName,
    productCategory,
    productImage,
    productPrice,
    cartQuantity,
    remainingQuantity,
    defaultProductQuantity,
  } = cartItem;

  // useDispatch function to dispatch action to the redux store
  const dispatch = useDispatch();

  const increaseCartHandler = productId => {
    // batch update after completed all actions
    batch(() => {
      // dispatch actions
      dispatch(increaseCartQuantity(productId));
      dispatch(decreaseProductQuantity(productId));
    });
  };
  const decreaseCartHandler = productId => {
    // batch update after completed all actions
    batch(() => {
      // dispatch actions
      dispatch(decreaseCartQuantity(productId));
      dispatch(increaseProductQuantity(productId));
    });
  };
  const deleteCartHandler = productId => {
    // batch update after completed all actions
    batch(() => {
      // dispatch actions
      dispatch(deleteCartItem(productId));
      dispatch(resetProductQuantity(productId));
    });
  };

  return (
    <div className="cartCard">
      <div className="flex items-center col-span-6 space-x-6">
        {/* <!-- cart image --> */}
        <img className="lws-cartImage" src={productImage} alt="product" />
        {/* <!-- cart item info --> */}
        <div className="space-y-2">
          <h4 className="lws-cartName">{productName}</h4>
          <p className="lws-cartCategory">{productCategory}</p>
          <p>
            BDT <span className="lws-cartPrice">{productPrice}</span>
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
        {/* <!-- amount buttons --> */}
        <div className="flex items-center space-x-4">
          <button
            className="lws-incrementQuantity"
            disabled={!remainingQuantity}
            onClick={() => increaseCartHandler(productId)}
          >
            <i className="text-lg fa-solid fa-plus"></i>
          </button>
          <span className="lws-cartQuantity">{cartQuantity}</span>
          <button
            className="lws-decrementQuantity"
            disabled={remainingQuantity === defaultProductQuantity}
            onClick={() => decreaseCartHandler(productId)}
          >
            <i className="text-lg fa-solid fa-minus"></i>
          </button>
        </div>
        {/* <!-- price --> */}
        <p className="text-lg font-bold">
          BDT{' '}
          <span className="lws-calculatedPrice">
            {cartQuantity * productPrice}
          </span>
        </p>
      </div>
      {/* <!-- delete button --> */}
      <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
        <button
          className="lws-removeFromCart"
          onClick={() => deleteCartHandler(productId)}
        >
          <i className="text-lg text-red-400 fa-solid fa-trash"></i>
        </button>
      </div>
    </div>
  );
}

export default CartItem;
